document.addEventListener("DOMContentLoaded", function () {
    $('body').on('click', '.js-open-submenu', function () {
        const submenu = $(this).parents('.nav-submenu');
        if (!submenu.hasClass('nav-submenu--opened')) {
            submenu.addClass('nav-submenu--opened');
            $('.nav-submenu__items').slideDown(200);
        } else {
            submenu.removeClass('nav-submenu--opened');
            $('.nav-submenu__items').slideUp(200);
        }
    });
    
    $('body').on('click',  function (e) {
        const submenu = $('.nav-submenu');
        const submenuLink = $('.js-open-submenu');
        const target = e.target;
        if (!submenuLink.is(target) && submenuLink.has(target).length === 0) {
            submenu.removeClass('nav-submenu--opened');
            $('.nav-submenu__items').slideUp(200);
        }
    });
    

    $('body').on('change', '.reliance-toggle-button input', function () {
        const checkbox = $(this);
        if (checkbox.prop('checked') === true) {
            $('body').addClass('reliance-page--light');
            $('.section-contacts').removeClass('section-contacts--dark');
            $('.header').removeClass('is_light');
        } else {
            $('body').removeClass('reliance-page--light');
            $('.section-contacts').addClass('section-contacts--dark');
            $('.header').addClass('is_light');
        }
    });
});
